/**
 * Palette a therapist can paint a zone with.
 *
 * Shared by both board pages: the patient page drew the same swatch row as the
 * therapist page but referenced a constant that only existed in the therapist
 * copy, so opening the zone editor there threw.
 */
export const ZONE_COLORS = ["#f59e0b", "#3b82f6", "#22c55e", "#ec4899", "#a855f7", "#ef4444"];
